
export interface BillingAccount {
    account_number: string;
    account_name: string;
    account_owner_client_number: string;
    account_owner_org_name: string;
    billing_city: string;
    billing_frequency: string;
    covered_person_count: number;
    current_amount_due: string;

    group_id: number;
}

export interface BillingAccountsState {
	billingAccounts: BillingAccount[],
	billingAccountsLoaded: boolean,
    currentBillingAccount: BillingAccount,
    requesting: boolean,
}

export enum BillingAccountsActions {
	SET_BILLING_ACCOUNTS = 'SET_BILLING_ACCOUNTS',
	UNLOAD_BILLING_ACCOUNTS = 'UNLOAD_BILLING_ACCOUNTS',
	SET_CURRENT_BILLING_ACCOUNT = 'SET_CURRENT_BILLING_ACCOUNT',
	BEGIN_BILLING_ACCOUNT_REQUEST = 'BEGIN_BILLING_ACCOUNT_REQUEST',
	END_BILLING_ACCOUNT_REQUEST = 'END_BILLING_ACCOUNT_REQUEST',
}